function isPxBlock(response?: { data?: object; status?: number }): boolean {
    const status = response?.status;
    const config = response?.data ?? {};
    return Boolean(status === 403 && config && 'appId' in config && 'blockScript' in config);
}

export default isPxBlock;
